import http from "../http-common";

/** Delete a file uploaded via upload-physical (attendance_note, carousel, etc.). */
const deletePhysicalFile = (payload) => {
  return http.post("/files/delete-physical", payload);
};

export const FileService = {
  deletePhysicalFile,
};
